<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.vc_code }}</em>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">基础信息</div>
        <div class="weui-form-preview__bd">
          <change-field
            label="名称"
            :old-value="form.main.vc_vename_old"
            :new-value="form.main.vc_vename_new"
          />
          <change-field
            label="收货地址"
            :old-value="form.main.vc_address_old"
            :new-value="form.main.vc_address_new"
          />
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">交易信息</div>
        <div class="weui-form-preview__bd">
          <change-field
            label="币种"
            :old-value="form.main.vc_currency_old"
            :new-value="form.main.vc_currency_new"
          />
          <change-field
            label="开户银行"
            :old-value="form.main.vc_bankcode_old"
            :new-value="form.main.vc_bankcode_new"
          />
          <change-field
            label="银行账号"
            :old-value="form.main.vc_bankaccount_old"
            :new-value="form.main.vc_bankaccount_new"
          />
          <change-field
            label="付款方式"
            :old-value="form.main.vc_payments_old"
            :new-value="form.main.vc_payments_new"
          />
          <change-field
            label="采购员"
            :old-value="form.main.vc_buyername_old"
            :new-value="form.main.vc_buyername_new"
          />
          <change-field
            label="外协线边仓"
            v-if="isMakeApp"
            :old-value="form.main.vc_wipwhname_old"
            :new-value="form.main.vc_wipwhname_new"
          />
          <change-field
            label="税率"
            :old-value="form.main.vc_taxrate_old"
            :new-value="form.main.vc_taxrate_new"
          />
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">变更信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.vc_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{
              form.main.vc_reason
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import ChangeField from "@/components/field/ChangeField";

export default {
  mixins: [form],
  components: {
    ChangeField,
  },
  data() {
    return {
      baseUrl: "/api/vendor/change",
    };
  },
};
</script>